import { useAuth } from "../context/AuthProvider";
import {Link} from "react-router-dom"
import React, { useState } from 'react';
import DeleteModal from '../cors/DeleteModal';
import { toast } from 'sonner';
import { BASE_URL } from '../apiConfig';
import { Phone, CreditCard, DollarSign, Mail } from 'lucide-react';
import { MdOutlineDeliveryDining as Moto } from "react-icons/md";

import { useLanguage } from "../context/LanguageProvider";

export default function LivreurList({ livreur, fetchLivreurs }) { 
  const { token, role, roles } = useAuth();
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteLivreur = async () => {
    setIsModalOpen(false);

    try {
      const res = await fetch(BASE_URL + `/api/livreurs/${livreur.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success("Delete successful");
        fetchLivreurs();
      } else {
        const err = await res.json()
        toast.error("Delete failed");
      }
    } catch (error) {
      toast.error("Delete failed");
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  return (
    <div className="group bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-[var(--color-primary-100)]">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <Moto className="h-7 w-7 md:w-12 md:h-12 text-[var(--color-primary-500)] bg-[var(--color-primary-100)] rounded-2xl p-1" />
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
                {livreur.name}
              </h3>
            </div>

            <div className="flex flex-col gap-2 w-full"> 
            <div className="flex justify-between items-center">
            <div className="flex gap-3 mt-1">
              <div className="flex gap-2 items-center">
                <label className="block text-xs font-medium text-gray-500 mb-1">{t('livreurs.email_label')}:</label>
                <span className="flex gap-1 max-w-max items-center px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs font-medium">
                  <Mail size={15} />  
                  {livreur.user?.email || 'N/A'}
                </span>
              </div>
              <div className="flex gap-2 items-center">
                <label className="block text-xs font-medium text-gray-500 mb-1">{t('livreurs.phone_label')}:</label>
                <span className="flex gap-1 max-w-max items-center px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs font-medium">
                  <Phone size={15} />  
                  {livreur.phone}
                </span>
              </div>
              <div className="flex gap-2 items-center">
                <label className="block text-xs font-medium text-gray-500 mb-1">{t('livreurs.delivery_price_label')}:</label>
                <span className="flex gap-1 max-w-max items-center px-3 py-1 bg-green-100 text-green-600 rounded-full text-xs font-semibold">
                  {livreur.prix_delivery} DH
                </span>
              </div>
              {livreur.rib && (
                  <div className="flex gap-2 items-center">
                    <label className="block text-xs font-medium text-gray-500 mb-1">{t('livreurs.rib_label')}:</label>
                    <span className="flex gap-1 max-w-max items-center px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs font-medium">
                      <CreditCard size={15} />  
                      {livreur.rib}
                    </span>
                  </div>
              )}
            </div>  
            </div>
            </div>
          </div>
          <div className="grid "> 
            <div className="flex justify-end gap-2">
            {
                (role === 1 || (role === 2 && roles.edit_fournisseur === 1)) &&
                  <Link to={`/livreurs/update/${livreur.id}`}>
                    <button className="p-2 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
                      <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </button>
                  </Link>
              }
              {
                (role === 1 || (role === 2 && roles.delete_fournisseur === 1)) &&
                  <button
                    onClick={() => setIsModalOpen(true)} 
                    className="p-2 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
                  >
                    <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                      />
                    </svg>
                  </button>
              }
            </div>
            <div className="flex text-[10px] text-gray-500 mt-2"> 
                <svg className="h-4 w-4 mr-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                {t('common.last_updated')}: {formatDate(livreur.updated_at)}
              </div>
          </div>
        </div>
      </div>
      <DeleteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={deleteLivreur}
        title={t('livreurs.delete_title')}
        message={t('livreurs.delete_message')}
        itemName={livreur.name}
      />
    </div>
  )
}
